import {
  get
} from "@/libs/axios";
import {
  notices
} from "@/libs/sysconst";
import router from '@/router'
const state = {
  logstate: undefined,
  info: {},
  safe: {},
  assets: {},
  logidValid: false, // 登录时验证框显示状态
  closeValid: true, //通知弹出
  show: undefined,
  notices
};

const actions = {
  // 获取用户基本数据
  async getUser({
    commit,
    dispatch
  }, v) {
    let res = await get("/Member/RZJProfile/GetUnreadInfo");
    if (res.err) {
      commit("info", {});
      commit("safe", {});
      commit("assets", {});
      commit("logstate", false);
      return;
    }
    commit("info", res);
    commit("logstate", true);
    if (v == "all") {
      dispatch("getSafe");
      dispatch("getAssets");
    }
  },
  // 获取用户安全中心数据
  async getSafe({
    commit
  }) {
    let res = await get("/Member/RZJProfile/UserInfo");
    // console.log(res);
    if (res.err) return commit("safe", {});
    commit("safe", res);
    // ID写入临时存储，防止多标签用户数据不对应
    let res2 = await get("/Member/RZJFund/InvestLoanInfo")
    let f = res2.TotalIncome > 0 ? true : false
    localStorage.setItem("userId", res.Id);
    let arr = [
      'borrow',
      'invest',
      'assets'
    ]
    let a = arr.indexOf(router.currentRoute.name) > -1;
    let b = state.closeValid;
    let c = JSON.parse(localStorage.getItem("arrid")) || [];
    let d = undefined;
    let e = state.logstate == true
    let g = state.safe.InvestTip
    // console.log(state)
    if (c && c.length > 0) {
      if (c.indexOf(res.Id) < 0) {
        d = true;
      }
    } else {
      d = true;
    }
    if (a && b && d && e && f && !g) {
      commit("show", true);
    } else {
      commit("show", false);
    }
  },
  // 获取用户资产信息
  async getAssets({
    commit
  }) {
    let res = await get("/Member/RZJFund/AccountInfo");
    if (res.err) return commit("assets", {});
    commit("assets", res);
  }
};

const mutations = {
  logstate(state, v) {
    state.logstate = v;
    if (v === false) localStorage.removeItem("userId");
  },
  info(state, v) {
    state.info = v;
  },
  safe(state, v) {
    state.safe = v;
  },
  assets(state, v) {
    state.assets = v;
  },
  unreadCount(state, v) {
    if (v == "-")
      state.info.UnreadInfoCount =
      state.info.UnreadInfoCount - 1 < 0 ? 0 : state.info.UnreadInfoCount - 1;
    else state.info.UnreadInfoCount = v;
  },
  logidValid(state, v) {
    state.logidValid = v;
  },
  closeValid(state, v) {
    state.closeValid = v;
  },
  show(state, v) {
    state.show = v
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
